var _g, _rect, _rect2, _rect3, _circle, _circle2, _rect4, _rect5, _rect6, _circle3, _circle4, _rect7, _rect8, _rect9, _circle5, _circle6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 419,
    height: 326,
    viewBox: "0 0 419 326",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_977_66782)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.9971,
    y: 70,
    width: 278,
    height: 186,
    fill: "#E7F0FF",
    fillOpacity: 0.6
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 122.003,
    y: 95,
    width: 207,
    height: 46,
    rx: 6,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 132.003,
    y: 105,
    width: 118,
    height: 9,
    rx: 4.5,
    fill: "#F9FAFB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 132.003,
    y: 122,
    width: 87,
    height: 9,
    rx: 4.5,
    fill: "#F9FAFB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 313.003,
    cy: 118,
    r: 6,
    fill: "url(#paint0_linear_977_66782)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.003,
    cy: 118,
    r: 6,
    fill: "url(#paint1_linear_977_66782)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 103.003,
    y: 211,
    width: 207,
    height: 46,
    rx: 6,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 113.003,
    y: 221,
    width: 118,
    height: 9,
    rx: 4.5,
    fill: "#F9FAFB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 113.003,
    y: 238,
    width: 87,
    height: 9,
    rx: 4.5,
    fill: "#F9FAFB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.003,
    cy: 234,
    r: 6,
    fill: "url(#paint2_linear_977_66782)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.003,
    cy: 234,
    r: 6,
    fill: "url(#paint3_linear_977_66782)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 166.003,
    y: 153,
    width: 207,
    height: 46,
    rx: 6,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 176.003,
    y: 163,
    width: 118,
    height: 9,
    rx: 4.5,
    fill: "#F9FAFB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 176.003,
    y: 180,
    width: 87,
    height: 9,
    rx: 4.5,
    fill: "#F9FAFB"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 357.003,
    cy: 176,
    r: 6,
    fill: "url(#paint4_linear_977_66782)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 348.003,
    cy: 176,
    r: 6,
    fill: "url(#paint5_linear_977_66782)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_977_66782",
    x: 0.99707,
    y: 0,
    width: 418,
    height: 326,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35,
    result: "effect1_foregroundBlur_977_66782"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_977_66782",
    x1: 313.003,
    y1: 112,
    x2: 313.003,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E28E86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C469DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_977_66782",
    x1: 304.003,
    y1: 112,
    x2: 304.003,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D98EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_977_66782",
    x1: 294.003,
    y1: 228,
    x2: 294.003,
    y2: 240,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E28E86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C469DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_977_66782",
    x1: 285.003,
    y1: 228,
    x2: 285.003,
    y2: 240,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D98EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_977_66782",
    x1: 357.003,
    y1: 170,
    x2: 357.003,
    y2: 182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89F293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AE0E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_977_66782",
    x1: 348.003,
    y1: 170,
    x2: 348.003,
    y2: 182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB746B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BE5C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderNotFound);
export default __webpack_public_path__ + "static/media/order-not-found.ffe7214302d4b393dda158b460b829e5.svg";
export { ForwardRef as ReactComponent };